export default __webpack_public_path__ + "static/media/YOOZ_PAYMENTS.da415493.png";